import { useCallback, useState, useEffect, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./UserComponent.module.css";
import { useNavigate } from "react-router";
import axios from "axios";
import { observer } from "mobx-react";
import config from "../../config/config";
import store from "../../Store/Store";
import EditUserLimits from "./EditUserLimits/EditUserLimits";
import NewUsers from "./newUsers/NewUsers";
import Notificatio from "./Notification/Notificatio";
import companyStore from "../../Store/Store";
import TopUp from "./TopUp/TopUp";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import NewUserPopup from "../Transaction/NewUserPopup/NewUserPopup";
import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Popover from "@mui/material/Popover";
import Tooltip from "@mui/material/Tooltip";
import {
  DataGrid,
  useGridApiRef,
  GridPreferencePanelsValue,
  getGridStringOperators,
  getGridSingleSelectOperators,
} from "@mui/x-data-grid";
import { useDebouncedLog } from "../../useDebouncedLog";
import NewTags from "./NewTags/NewTags";

/* ------------------------------------------------------------------
 * Grid sizing.
 * The grid is no longer autoHeight: autoHeight renders every row and
 * ignores the container, which pushed the pagination footer below the
 * fold. Instead the wrapper gets a definite height that grows with the
 * rows on the page and stops at 90vh — past that the grid scrolls its
 * own body and the header + footer stay put.
 * ------------------------------------------------------------------ */
const GRID_ROW_HEIGHT = 64;
const GRID_HEADER_HEIGHT = 56; // default columnHeaderHeight
const GRID_FOOTER_HEIGHT = 53; // pagination row
const GRID_MAX_HEIGHT = "98vh";
// rows to reserve space for when the grid is empty, so the no-rows /
// all-columns-hidden overlays have room
const GRID_MIN_ROWS = 3;

// Text columns get exactly one operator, so the operator dropdown can be
// hidden and the panel shows nothing but a text box.
const CONTAINS_ONLY = getGridStringOperators().filter(
  (operator) => operator.value === "contains",
);

// Single-select columns get "is", which renders a value dropdown instead.
const IS_ONLY = getGridSingleSelectOperators().filter(
  (operator) => operator.value === "is",
);


// Same parser the built-in GridToolbarQuickFilter uses.
const parseQuickFilter = (input) =>
  input.split(" ").filter((word) => word !== "");

const EMPTY_FILTER_MODEL = {
  items: [],
  quickFilterValues: [],
  // hidden columns stay searchable
  quickFilterExcludeHiddenColumns: false,
};

// Columns hidden on first load. Lives here rather than in initialState
// because columnVisibilityModel is controlled — a controlled prop wins over
// initialState, so initialState would silently do nothing.
const DEFAULT_HIDDEN_COLUMNS = {
  __tags: false,
};

const roleLabel = (roles = []) =>
  roles.includes("OWNER")
    ? "Owner"
    : roles.includes("ADMIN")
      ? "Admin"
      : roles.includes("CUPI_VIEW_ADMIN")
        ? "Viewer"
        : roles.includes("CUPI_COMPANY_EMPLOYEE")
          ? "User"
          : "NA";

const UserComponent = observer(({ className = "" }) => {
  const [data, setData] = useState([]);
  const [flag, setFlag] = useState(false);
  const [WalletInfo, setWalletinfo] = useState("Loading...");
  const [companyname, setcompanyname] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [flagNotifi, setFlagNotifi] = useState(false);
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(true);
  const [editUser, setEdituser] = useState(false);
  const [EditTopUp, setEditTopUp] = useState(false);
  const [topUpNoti, settopUpNoti] = useState(false);
  const [isViewAdmin, setViewAdmin] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [advKycStatus, setAdvKycStatus] = useState("");
  const [whitelistingStatus, setWhitelistingStatus] = useState("");
  const [onboardingStatus, setOnboardingStatus] = useState("");
  const [copied, setCopied] = useState(false);
  const [kycStatus, setKycStatus] = React.useState("");
  const [kycStatusFilter, setKycStatusFilter] = React.useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [LinkCopied, setLinkCopied] = useState(false);
  const [LinkResend, setLinkResend] = useState(false);
  const [ResendReq, setResendReq] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  // --- DataGrid state (all controls live in the toolbar row) ---
  const apiRef = useGridApiRef();
  const [serchFilter, setSerchFilter] = useState("");
  const [filterModel, setFilterModel] = useState(EMPTY_FILTER_MODEL);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [panelAnchorEl, setPanelAnchorEl] = useState(null);
  // the per-row action menu, anchored to its button so it isn't clipped
  // by the grid's cell overflow
  const [actionMenu, setActionMenu] = useState({ anchorEl: null, row: null });
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(
    DEFAULT_HIDDEN_COLUMNS,
  );
  // The columns panel always anchors here, whatever opened it.
  const columnsButtonRef = useRef(null);

  var logUserManagementVisited;
  var logCompanyDetailFetched;
  var logCupiUserFetched;
  var logResendKycLinkSend;
  var logKycLinkCopied;
  var logTopupOpen;
  var logEditUser;
  var logStartUserKyc;
  var logOpenTopUp;
  var logBulkUserClicked;
  var logAddAxisNewUserClicked;
  var logAddPineNewUserClicked;
  var logKycStatusFilterOpened;
  try {
    logUserManagementVisited = useDebouncedLog(
      "admin_users_screen_visited",
      500,
    );
    logCompanyDetailFetched = useDebouncedLog(
      "admin_company_detail_fetched",
      500,
    );
    logCupiUserFetched = useDebouncedLog("admin_get_cupi_users_fetched", 500);
    logResendKycLinkSend = useDebouncedLog("admin_resend_kyc_link_send", 500);
    logKycLinkCopied = useDebouncedLog("admin_kyc_link_copied", 500);
    logTopupOpen = useDebouncedLog("admin_topup_opened", 500);
    logEditUser = useDebouncedLog("admin_edit_user_clicked", 500);
    logStartUserKyc = useDebouncedLog("admin_start_user_kyc");
    logOpenTopUp = useDebouncedLog("admin_open_top_up");
    logBulkUserClicked = useDebouncedLog("admin_bulk_user_clicked");
    logAddAxisNewUserClicked = useDebouncedLog("admin_axis_add_user_clicked");
    logAddPineNewUserClicked = useDebouncedLog("admin_pine_add_user_clicked");
    logKycStatusFilterOpened = useDebouncedLog("admin_kyc_status_opened");
  } catch (err) {
    console.log("error", err);
  }

  
const SANSOURCE = "var( --font-source-sans-3), sans-serif";

// Body / cell text colour, matching --color-dimgray-300.
const HEADER_COLOR = "#666666";
const TEXT_COLOR = "#4C4E64";
// Accent used for checked states and the panel's text buttons.
const ACCENT_COLOR = "#3246A9";
const MUTED_COLOR = "#8C8C8C";

const PANEL_SX = {
  // catch-all for nodes MUI doesn't expose a stable class for
  "& , & *": {
    fontFamily: SANSOURCE,
  },
  "& .MuiDataGrid-panelWrapper": {
    fontFamily: SANSOURCE,
  },
  // column rows: "DATE", "PAID TO", ...
  "& .MuiFormControlLabel-label, & .MuiTypography-root": {
    fontFamily: SANSOURCE,
    fontSize: 14,
    fontWeight: 500,
    color: TEXT_COLOR,
    letterSpacing: 0,
    textTransform: "none",
  },
  // the panel's own search box and the filter form inputs
  "& .MuiInputBase-root, & .MuiInputBase-input, & .MuiFormLabel-root, & .MuiSelect-select":
    {
      fontFamily: SANSOURCE,
      fontSize: 14,
      color: TEXT_COLOR,
    },
  "& .MuiInputBase-input::placeholder": {
    fontFamily: SANSOURCE,
    color: MUTED_COLOR,
    opacity: 1,
  },
  // Show/Hide All + RESET footer
  "& .MuiDataGrid-panelFooter .MuiButton-root": {
    fontFamily: SANSOURCE,
    fontSize: 13,
    fontWeight: 600,
    textTransform: "none",
    color: ACCENT_COLOR,
  },
  // checkboxes, otherwise MUI's default blue
  "& .MuiCheckbox-root.Mui-checked, & .MuiCheckbox-root.MuiCheckbox-indeterminate":
    {
      color: ACCENT_COLOR,
    },
     "& .MuiPaper-root, & .MuiDataGrid-paper": {
    borderRadius: "var(--br-xs)",   // 12px, matches your inputs
    overflow: "hidden",             // clips children to the radius
  },
  "& .MuiDataGrid-panelWrapper": {
    borderRadius: "var(--br-xs)",
    overflow: "hidden",
  },
};
  const SELECT_MENU_SX = {
    borderRadius: "var(--br-xs)",
    "& .MuiMenuItem-root": {
      fontFamily: SANSOURCE,
      fontSize: 14,
      fontWeight: 500,
      color: TEXT_COLOR,
      letterSpacing: 0,
      textTransform: "none",
    },
    "& .MuiMenuItem-root.Mui-selected": {
      color: ACCENT_COLOR,
      backgroundColor: "rgba(50, 70, 169, 0.08)",
    },
    "& .MuiMenuItem-root.Mui-selected:hover": {
      backgroundColor: "rgba(50, 70, 169, 0.12)",
    },
  };
  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
      } else {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  };

  useEffect(() => {
    try {
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }
      const obj = {
        ledger_label: store.Company_Id,
      };
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_cupi_company_detail`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };

      axios
        .request(payload)
        .then((res) => {
          setWalletinfo(res.data.data);
          store.setInsightAvilable(res.data.data.metabase_account_created);
          try {
            logCompanyDetailFetched();
          } catch (er) {
            console.log("error%o", er);
          }
        })
        .catch((er) => {
          console.log("error-->", er);
        });
      setcompanyname(store.companyName);
    } catch (err) {
      console.log("Error in walletInfo", err);
    }
  }, [store.refresh]);

  useEffect(() => {
    logUserManagementVisited();
  }, [logUserManagementVisited]);

  useEffect(() => {
    if (!store.Company_Id) return;

    const fetchStatus = async () => {
      try {
        let tokens = localStorage.getItem("authToken");
        let parsedTokens = JSON.parse(tokens);
        const res = await fetch(
          `${config.kyc_api_endpoint}/user/status?company_id=${store.Company_Id}`,
          {
            method: "POST", // ← changed to POST
            headers: {
              "Content-Type": "application/json",
              aws_cognito_id_token: parsedTokens.IdToken,
              aws_cognito_access_token: parsedTokens.AccessToken,
            },
            body: JSON.stringify({
              company_id: store.Company_Id,
              kyc_company_id: store.KycCompanyId,
            }),
          },
        );

        const data = await res.json();
        const statusMap = Object.fromEntries(
          data.status.map((s) => [s.key, s.value]),
        );
        console.log("RESPONSE_________>", data);

        setAdvKycStatus(statusMap["advanced-kyc"]);
        setWhitelistingStatus(statusMap["whitelisting"]);
        setOnboardingStatus(data.onboarding_status);
        store.setCompTempId(data.company_id);
        store.setKycCompanyId(data?.company_id);
        store.setTradeName(data.trade_name);
        if (!res.ok || !data.success) {
          throw new Error(data.error || "Failed to fetch status");
        }
      } catch (err) {
        if (err.name !== "AbortError") {
          // setError(err.message || "Something went wrong");
        }
      } finally {
        // setLoading(false);
      }
    };

    fetchStatus();
  }, [store.company_temp_id, store.refresh]);

  useEffect(() => {
    store.setSelectedExpenseMobileNo("");
    let auth = localStorage.getItem("authToken");
    if (!auth) {
      navigate("/login");
      return;
    }
    const obj = {
      ledger_label: store.Company_Id,
    };
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    const expired = isTokenExpired(parsedTokens.IdToken);
    if (expired) {
      parsedTokens = getNewTokens(parsedTokens);
    }
    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/get_cupi_compnay_users`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    axios
      .request(payload)
      .then((res) => {
        setData(res.data.data);
        setcompanyname(res.data.company_name);
        try {
          logCupiUserFetched();
        } catch (err) {
          console.log("error", err);
        }
      })
      .catch((er) => {
        console.log(er);
      });
  }, [refresh, store.refresh]);

  /* ----------------------------------------------------------------
   * Search -> MUI quick filter.
   * The grid owns the filtering; this just hands it the parsed values,
   * debounced the way the built-in quick filter does.
   * ---------------------------------------------------------------- */
  useEffect(() => {
    const timeout = setTimeout(() => {
      apiRef.current?.setQuickFilterValues(
        parseQuickFilter(serchFilter.trim()),
      );
      setPaginationModel((prev) => ({ ...prev, page: 0 }));
    }, 250);

    return () => clearTimeout(timeout);
  }, [serchFilter]);

  const resetGridFilters = () => {
    setSerchFilter("");
    setSearchOpen(false);
    setFilterModel(EMPTY_FILTER_MODEL);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const toggleSearch = () => {
    setSearchOpen((open) => {
      if (open) {
        setSerchFilter(""); // closing clears the quick filter
      }
      return !open;
    });
  };

  const handlenavi = () => {
    navigate("/content/view-user");
  };

  const getKycStatus = (user) => {
    if (user?.has_wallet) return "Completed";

    const status = user?.kyc_info?.initiate_kyc_bp_response?.status;

    if (status === "kyc_initiated") return "kyc_initiated";
    if (status === "kyc_link_expired") return "kyc_link_expired";

    // fallback cases
    if (!user?.has_wallet) return "NA";
    return "N/A";
  };

  function getKycDisplayStatus(detail) {
    if (detail.has_wallet) {
      return "Completed";
    }

    const status = detail?.kyc_info?.initiate_kyc_bp_response?.status;

    if (detail?.kyc_info?.kyc_initiate_on && status === "kyc_initiated") {
      return "Pending";
    }

    if (status === "kyc_link_expired") {
      return "Expired";
    }

    if (!detail.has_wallet) {
      return "NA";
    }

    return "N/A";
  }

  const onAddNewUsersClick = useCallback(() => {
    setFlag(true);
    store.setEmpDetails("");
  }, []);

  function OpenTopup(detail) {
    try {
      store.setUserId(detail.user_id);
      store.setName(detail.name);
      store.setSelectedEmail(detail.email);
      store.setCreate_at(detail.create_at);
      store.setPhoneNo(detail?.mobile_no);
      store.setUserRoles(detail?.roles);
      if (
        detail?.topup_startdate != undefined &&
        detail.topup_enddate != undefined &&
        detail?.topup_startdate != "" &&
        detail.topup_enddate != ""
      ) {
        store.setTopUpStatus(detail?.topup_status);
        store.setTopUpName(detail?.topup_name);
        store.setTopUpTotalLimit(detail?.topup_total_limit);
        store.setTopUpDailyLimit(detail?.topup_daily_limit);
        store.setTopUpNote(detail?.topup_note ? detail?.topup_note : "");
        store.setStartDate(detail?.topup_startdate);
        store.setEndDate(detail?.topup_enddate);
      } else {
        store.setTopUpStatus("");
        store.setTopUpName("");
        store.setTopUpTotalLimit("");
        store.setTopUpDailyLimit("");
        store.setTopUpNote("");
        store.setStartDate("");
        store.setEndDate("");
      }
      try {
        logTopupOpen();
      } catch (err) {
        console.log("error%o", err);
      }
      setEditTopUp(true);
    } catch (err) {
      console.log("error", err);
    }
  }

  const copyToClipboard = async (linkToCopy) => {
    try {
      await navigator.clipboard.writeText(linkToCopy);
      setCopied(true);

      setTimeout(() => setCopied(false), 2000);
      try {
        logKycLinkCopied();
      } catch (er) {
        console.log("error%o", er);
      }
    } catch (err) {
      console.error("Failed to copy:", err);
      setCopied(false);
    }
  };

  function removePlus91(number) {
    if (!number) return number;

    return number
      .trim()
      .replace(/\s+/g, "")
      .replace(/^(?:\+91|91|0091|091|\+0091)/, "")
      .replace(/^0+/, ""); // optional: remove leading zeros too
  }

  const resendKycLink = async (detail) => {
    try {
      const rawAuth = localStorage.getItem("authToken");
      let parsedTokens = rawAuth ? JSON.parse(rawAuth) : {};
      let ParsedNUmber = removePlus91(detail?.mobile_no);
      let obj = {
        initiate_kyc_bp_response: detail?.kyc_info?.initiate_kyc_bp_response,
        kyc_initiate_on: detail?.kyc_info?.kyc_initiate_on,
        user_mobile_no: ParsedNUmber,
        ledger_label: store.Company_Id,
      };
      const expired = isTokenExpired(parsedTokens?.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/refresh_expired_link_and_resend_kyc_link`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };
      axios
        .request(payload)
        .then((res) => {
          setResendReq(true);
          try {
            logResendKycLinkSend();
          } catch (err) {
            console.log("error%o", err);
          }
        })
        .catch((err) => {
          console.log("error: %o".err);
        });
    } catch (err) {
      console.log("err", err);
    }
  };

  const openEditUser = (detail) => {
    store.setUserId(detail?.user_id);
    store.setName(detail?.name);
    store.setSelectedEmail(detail?.email);
    store.setTxnLimit(detail?.perTxnLimit);
    store.setDailyLimit(detail?.dailyLimit);
    store.setmonthlyLimit(detail?.monthlyLimit);
    store.setCreate_at(detail?.create_at);
    store.setPhoneNo(detail?.mobile_no);
    store.setStatus(detail?.status);
    store.setEnabled(true);
    store.setEmpDetails("");
    store.setUserRoles(detail?.roles);
    store.setTags(detail?.tags?.split(","));
    store.setEmpDetails({
      Empcode: detail?.employee_info?.employee_code,
      location: detail?.employee_info?.employee_location,
      Department: detail?.employee_info?.employee_department,
    });
    if (companyStore.userType != "AxisUser") {
      store.setUserHasWallet(detail?.has_wallet);
      store.setUserKycInfo(detail?.kyc_info);
    }

    setEdituser(true);
    try {
      logEditUser();
    } catch (err) {
      console.log("error", err);
    }
  };

  const gridRows = useMemo(
    () =>
      [...(data || [])].reverse().map((detail, index) => ({
        ...detail,
        id: `${detail.user_id || detail.mobile_no || "row"}-${index}`,
        // same field the action menu reads
        Kyc_status: getKycDisplayStatus(detail),
        __email: detail?.email == "undefined" ? "-" : detail?.email || "-",
        __perTxn: String(detail?.perTxnLimit ?? ""),
        __daily: String(detail?.dailyLimit ?? ""),
        __monthly: String(detail?.monthlyLimit ?? ""),
        __topup: detail?.topup_status || "inactive",
        __role: roleLabel(detail?.roles || []),
        __tags: detail?.tags || "",
      })),
    [data],
  );

  // Dropdown options for the single-select columns, taken from the rows
  // actually loaded so the list never offers an empty result.
  const topupOptions = useMemo(
    () => [...new Set(gridRows.map((row) => row.__topup))].sort(),
    [gridRows],
  );
  const roleOptions = useMemo(
    () => [...new Set(gridRows.map((row) => row.__role))].sort(),
    [gridRows],
  );
  const kycOptions = useMemo(
    () => [...new Set(gridRows.map((row) => row.Kyc_status))].sort(),
    [gridRows],
  );

  // display:block — overflow/text-overflow are ignored on an inline element,
  // so without it the ellipsis never kicks in and long values push their
  // cell wider than flex allocated.
  const ellipsisCell = (value) => (
    <Tooltip title={value || ""}>
      <span
        style={{
          display: "block",
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {value}
      </span>
    </Tooltip>
  );

  /* ----------------------------------------------------------------
   * Columns.
   * The visible columns use flex + minWidth rather than fixed widths, so
   * they divide whatever the card actually gives them the way the old
   * width:100% <table> did. Floor is ~990px with KYC Status, ~890px
   * without it — under any realistic card width, so no horizontal scroll.
   * Tags is hidden by default and keeps a fixed width: un-hiding it should
   * widen the grid, not squeeze every other column.
   * ---------------------------------------------------------------- */
  const columns = useMemo(() => {
    const cols = [
      {
        field: "name",
        headerName: "NAME",
        flex: 1.4,
        minWidth: 110,
        filterOperators: CONTAINS_ONLY,
        renderCell: (params) => (
          <div
            className={styles.data12}
            // minWidth:0 or the flex child refuses to shrink below its
            // content and the ellipsis never applies
            style={{ cursor: "pointer", width: "100%", minWidth: 0 }}
            onClick={() => {
              store.setSelectedExpenseMobileNo(params.row.mobile_no);
              navigate("/content/transactions");
            }}
          >
            {ellipsisCell(params.value)}
          </div>
        ),
      },
      {
        field: "mobile_no",
        headerName: "PHONE NO",
        flex: 1.2,
        minWidth: 105,
        filterOperators: CONTAINS_ONLY,
      },
      {
        field: "__email",
        headerName: "EMAIL",
        flex: 1.4,
        minWidth: 110,
        filterOperators: CONTAINS_ONLY,
        renderCell: (params) => ellipsisCell(params.value),
      },
      {
        field: "__perTxn",
        headerName: "PER TXN LIMIT (₹)",
        flex: 1,
        minWidth: 95,
        headerAlign: "right",
        align: "right",
        filterOperators: CONTAINS_ONLY,
        sortComparator: (a, b) => Number(a) - Number(b),
      },
      {
        field: "__daily",
        headerName: "DAILY LIMIT (₹)",
        flex: 1,
        minWidth: 95,
        headerAlign: "right",
        align: "right",
        filterOperators: CONTAINS_ONLY,
        sortComparator: (a, b) => Number(a) - Number(b),
      },
      {
        field: "__monthly",
        headerName: "MONTHLY LIMIT (₹)",
        flex: 1.1,
        minWidth: 105,
        headerAlign: "right",
        align: "right",
        filterOperators: CONTAINS_ONLY,
        sortComparator: (a, b) => Number(a) - Number(b),
      },
      {
        field: "__topup",
        headerName: "TOP-UP STATUS",
        flex: 1.1,
        minWidth: 105,
        type: "singleSelect",
        valueOptions: topupOptions,
        headerAlign: "center",
        align: "center",
        filterOperators: IS_ONLY,
      },
      {
        field: "__role",
        headerName: "ROLES",
        flex: 0.9,
        minWidth: 85,
        type: "singleSelect",
        headerAlign: "center",
        align: "center",
        valueOptions: roleOptions,
        filterOperators: IS_ONLY,
      },
      {
        field: "__tags",
        headerName: "TAGS",
        width: 180,
        filterOperators: CONTAINS_ONLY,
        renderCell: (params) => ellipsisCell(params.value),
      },
    ];

    if (store.userType != "AxisUser") {
      cols.push({
        field: "Kyc_status",
        headerName: "KYC STATUS",
        flex: 1.1,
        minWidth: 100,
        headerAlign: "center",
        align: "center",
        type: "singleSelect",
        valueOptions: kycOptions,
        filterOperators: IS_ONLY,
        renderCell: (params) =>
          store.isUserOwner &&
            !params.row.has_wallet &&
            !params.row?.kyc_info?.initiate_kyc_bp_response?.status ? (
            <div
              className={styles.StartKycButton}
              onClick={() => {
                const detail = params.row;
                store.setUserId(detail.user_id);
                store.setName(detail.name);
                store.setSelectedEmail(detail.email);
                store.setTxnLimit(detail.perTxnLimit);
                store.setDailyLimit(detail.dailyLimit);
                store.setmonthlyLimit(detail.monthlyLimit);
                store.setCreate_at(detail.create_at);
                store.setPhoneNo(detail.mobile_no);
                store.setStatus(detail.status);
                store.setEnabled(true);
                store.setEmpDetails("");
                store.setUserRoles(detail.roles);
                store.setTags(detail.tags?.split(",") ?? []);
                store.setEmpDetails({
                  Empcode: detail?.employee_info?.employee_code,
                  location: detail?.employee_info?.employee_location,
                  Department: detail?.employee_info?.employee_department,
                });
                if (companyStore.userType !== "AxisUser") {
                  store.setUserHasWallet(detail.has_wallet);
                  store.setUserKycInfo(detail.kyc_info);
                }

                setEdituser(true);
                try {
                  logStartUserKyc();
                } catch (err) {
                  console.log("error", err);
                }
              }}
            >
              Start KYC
            </div>
          ) : (
            <div className={styles.data11}>{params.value}</div>
          ),
      });
    }

    cols.push({
      field: "__action",
      headerName: "ACTION",
      // icon button only — no reason to flex
      width: 80,
      sortable: false,
      filterable: false,
      // hideable: false, // allow hide-all so the empty-state overlay can appear
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <button
          style={{ background: "none", border: "none", cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            setActionMenu({ anchorEl: e.currentTarget, row: params.row });
          }}
        >
          <img src="/ActionBtn.svg" alt="" />
        </button>
      ),
    });

    return cols;
  }, [topupOptions, roleOptions, kycOptions, store.userType, store.isUserOwner]);

  const openFilterPanel = (event) => {
    setPanelAnchorEl(event.currentTarget);
    apiRef.current?.showFilterPanel();
  };

  const openColumnsPanel = (event) => {
    // Pinned to the toolbar icon so the panel lands in the same place whether
    // it was opened from the toolbar or from the all-columns-hidden state.
    setPanelAnchorEl(columnsButtonRef.current ?? event?.currentTarget ?? null);
    apiRef.current?.showPreferences(GridPreferencePanelsValue.columns);
  };

  const closeActionMenu = () => setActionMenu({ anchorEl: null, row: null });

  /* ----------------------------------------------------------------
   * The grid has no "no visible columns" state of its own: hide every
   * column and it renders an empty shell with no overlay. Detect it here
   * and put a Manage Columns action in that space instead.
   * ---------------------------------------------------------------- */
  const allColumnsHidden = useMemo(
    () => columns.every((col) => columnVisibilityModel[col.field] === false),
    [columns, columnVisibilityModel],
  );

  /* ----------------------------------------------------------------
   * Wrapper height: grows with the rows on the current page, capped at
   * 90vh. gridRows is the pre-pagination row set, so this is an upper
   * bound — a page filtered down to fewer rows simply leaves a little
   * empty space, it never clips the footer.
   * ---------------------------------------------------------------- */
  const rowsOnPage =
    Math.min(gridRows.length, paginationModel.pageSize) || GRID_MIN_ROWS;
  const gridHeight = `min(${GRID_MAX_HEIGHT}, ${GRID_HEADER_HEIGHT + GRID_FOOTER_HEIGHT + rowsOnPage * GRID_ROW_HEIGHT
    }px)`;

  return (
    <div className={styles.pageContainer + " " + className}>
      <div className={styles.frameParent}>
        <div className={styles.cards16pxContainer111}>
          <div className={styles.cards16pxContainer}>
            {companyStore.userType != "AxisUser" && (
              <div className={styles.cards16px}>
                <div className={styles.saveMoney1044644423Parent}>
                  <div className={styles.saveMoney1044644423}>
                    <img
                      className={styles.vectorIcon}
                      alt=""
                      src="/vector.svg"
                    />
                  </div>
                  <div className={styles.availableBalanceParent}>
                    <div className={styles.availableBalance}>
                      Available Balance*
                    </div>
                     <div className={WalletInfo?.balance_cr_dr?.toLowerCase() === "dr" ? styles.divRed : styles.div}>
                        {WalletInfo?.balance_cr_dr?.toLowerCase() === "dr"
                          ? `-₹${WalletInfo?.balance || "Loading..."}`
                          : `₹${WalletInfo?.balance || "Loading..."}`}
                      </div>
                  </div>
                </div>

                {store.Company_Id != "AxisDemo" && (
                  <div className={styles.saveMoney1044644423Parent1}>
                    <div className={styles.saveMoney1044644423row}>
                      <div className={styles.saveMoney1044644423}>
                        <img
                          className={styles.vectorIcon}
                          alt=""
                          src="/wallet.svg"
                        />
                      </div>
                      <div className={styles.availableBalanceParent1}>
                        <div className={styles.availableBalance}>
                          Account Details*
                          <div className={styles.tiptool}></div>
                        </div>

                        <div className={styles.div16}>
                          <div>Ac.no</div>
                          <div>:</div>
                          <div>{WalletInfo?.van?.acc_no || "Loading..."}</div>
                        </div>
                        <div className={styles.div16}>
                          <div>IFSC</div>
                          <div>:</div>
                          <div>{WalletInfo?.van?.ifsc || "Loading..."}</div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={styles.RedirectLink}
                      onClick={() => {
                        navigate("/content/kycValidation?tab=2");
                      }}
                    >
                      How to load money? Click here
                    </div>
                  </div>
                )}
              </div>
            )}
            {companyStore.userType == "AxisUser" && (
              <div className={styles.welcomesunshineinfotechWrapper}>
                <div className={styles.welcomesunshineinfotech}>
                  {companyStore.userType == "AxisUser" &&
                    !store.isUserViewAdmin &&
                    !store.isUserGlobalViewAdmin && (
                      <button
                        className={styles.addNewUsers}
                        onClick={() => {
                          navigate("/content/bulkUser");
                          try {
                            logBulkUserClicked();
                          } catch (err) {
                            console.log("error", err);
                          }
                        }}
                      >
                        <img
                          className={styles.plusCircleIcon}
                          alt=""
                          src="/Layer_14.svg"
                        />
                        <b className={styles.newUser}>Bulk users </b>
                      </button>
                    )}

                  {companyStore.userType == "AxisUser" &&
                    !store.isUserViewAdmin &&
                    !store.isUserGlobalViewAdmin && (
                      <button
                        className={styles.addNewUsers}
                        onClick={() => {
                          onAddNewUsersClick();
                          try {
                            logAddAxisNewUserClicked();
                          } catch (err) {
                            console.log("error", err);
                          }
                        }}
                      >
                        <img
                          className={styles.plusCircleIcon}
                          alt=""
                          src="/pluscircle.svg"
                        />
                        <b className={styles.newUser}>New user</b>
                      </button>
                    )}
                </div>
              </div>
            )}
            {!showBanner && companyStore.userType != "AxisUser" && (
              <NewUserPopup
                advKycStatus={advKycStatus}
                whitelistingStatus={whitelistingStatus}
                onboardingStatus={onboardingStatus}
                setShowBanner={setShowBanner}
                showOthers={false} 
              />
            )}
          </div>
          {LinkCopied && (
            <div className={styles.Copylink}>
              <img
                className={styles.linkCopied}
                alt=""
                src="/check-circle.svg"
              />
              KYC Link have been Copied.
            </div>
          )}
          {LinkResend && (
            <div className={styles.Copylink}>
              <img
                className={styles.linkCopied}
                alt=""
                src="/check-circle.svg"
              />
              KYC Link have been Resent.
            </div>
          )}
        </div>
        <div className={styles.frameGroup}>
          <div
            className={styles.feeStatementDataTable}
            style={{ minWidth: 0, maxWidth: "100%", overflow: "hidden" }}
          >
            <div className={styles.top}>
              <div className={styles.filterWrapper}>
                <div className={styles.filter}>
                  <div className={styles.containertext}> User List</div>{" "}
                </div>
                <div className={styles.filter}>
                  {/* add user — unchanged */}
                  {companyStore.userType != "AxisUser" &&
                    (store.isUserOwner || store.isUserAdmin) && (
                      <button
                        className={styles.addNewUsers}
                        onClick={() => {
                          companyStore.setEmpDetails();
                          onAddNewUsersClick();
                          try {
                            logAddPineNewUserClicked();
                          } catch (err) {
                            console.log("error", err);
                          }
                        }}
                      >
                        <img
                          className={styles.plusCircleIcon}
                          alt=""
                          src="/pluscircle.svg"
                        />
                        <b className={styles.newUser}>Add New User</b>
                      </button>
                    )}

                  {/* search — MUI quick filter */}
                  {/* search — hidden until the search button is pressed */}
                  {searchOpen && (
                    <TextField
                      size="small"
                      autoFocus
                      placeholder="Search..."
                      value={serchFilter}
                      onChange={(e) => setSerchFilter(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Escape") toggleSearch();
                      }}
                      sx={{
                        minWidth: 220,
                        "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                      }}
                    />
                  )}

                  {/* search toggle */}
                  <button className={styles.FilterField} onClick={toggleSearch}>
                    <div className={styles.content1}>
                      <img
                        className={styles.leadingIcon}
                        alt=""
                        src="/leadingicon.svg"
                      />
                    </div>
                  </button>

                  {/* show / hide columns */}
                  <button
                    ref={columnsButtonRef}
                    className={styles.FilterField}
                    onClick={openColumnsPanel}
                  >
                    <div className={styles.content1}>
                      <img
                        className={styles.leadingIcon}
                        alt=""
                        src="/ThreeHorizontalLine.svg"
                      />
                    </div>
                  </button>

                  {/* column filter — column + value, no operator */}
                  <button
                    className={styles.FilterField}
                    onClick={openFilterPanel}
                  >
                    <div className={styles.content1}>
                      <img
                        className={styles.leadingIcon}
                        alt=""
                        src="/ThreeVerticalline.svg"
                      />
                    </div>
                  </button>

                  <button
                    className={styles.reLoadTable}
                    onClick={() => {
                      resetGridFilters();
                      setColumnVisibilityModel({ ...DEFAULT_HIDDEN_COLUMNS });
                      if (refresh) {
                        setRefresh(false);
                        return;
                      }
                      setRefresh(true);
                    }}
                  >
                    <img
                      className={styles.vectorIcon1}
                      alt=""
                      src="/vector7.svg"
                    />
                  </button>
                </div>
              </div>
              <div className={styles.topChild} />
            </div>

            {/* width follows the card, not the viewport: a calc(100vw - …)
                maxWidth can resolve wider than the card, and the flex columns
                would then size against space the card doesn't have */}
            <Box
              sx={{
                position: "relative",
                width: "100%",
                minWidth: 0,
                // definite height, capped at 90vh — the grid scrolls its own
                // rows, so the header and the pagination footer stay visible
                height: gridHeight,
                ...(allColumnsHidden && { minHeight: 280 }),
                overflow: "hidden",
              }}
            >
              <DataGrid
                apiRef={apiRef}
                rows={gridRows}
                columns={columns}
                rowHeight={GRID_ROW_HEIGHT}
                columnHeaderHeight={GRID_HEADER_HEIGHT}
                disableColumnMenu
                disableRowSelectionOnClick
                filterModel={filterModel}
                onFilterModelChange={(model) => {
                  setFilterModel(model);
                  setPaginationModel((prev) => ({ ...prev, page: 0 }));
                }}
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={setColumnVisibilityModel}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[10, 25, 50, 100]}
                slotProps={{
                  baseSelect: {
                    MenuProps: { PaperProps: { sx: SELECT_MENU_SX } },
                  },
                  panel: {
                    anchorEl: panelAnchorEl,
                    placement: "bottom-end",
                    sx: PANEL_SX,
                  },
                  filterPanel: {
                    filterFormProps: {
                      logicOperatorInputProps: { sx: { display: "none" } },
                      operatorInputProps: { sx: { display: "none" } },
                      columnInputProps: { sx: { minWidth: 160 } },
                      valueInputProps: {
                        InputComponentProps: { sx: { minWidth: 200 } },
                      },
                    },
                    sx: {
                      "& .MuiDataGrid-filterFormLogicOperatorInput": {
                        display: "none",
                      },
                      "& .MuiDataGrid-panelWrapper": { minWidth: 460 },
                      "& .MuiDataGrid-panelContent": { overflowX: "hidden" },
                      "& .MuiDataGrid-filterForm": {
                        p: 2,
                        gap: 1,
                        alignItems: "flex-end",
                        flexWrap: "wrap",
                      },
                      "& .MuiDataGrid-filterFormDeleteIcon": {
                        flexShrink: 0,
                        alignSelf: "flex-end",
                      },
                    },
                  },
                }}
                localeText={{
                  noRowsLabel: "No Users found.",
                  noResultsOverlayLabel:
                    "No users match this search or filter.",
                  filterPanelColumns: "Column",
                  filterPanelInputLabel: "Value",
                  filterPanelInputPlaceholder: "Filter value",
                }}
                sx={{
                  // fills the capped wrapper; the body scrolls, the footer doesn't
                  height: "100%",
                  width: "100%",
                  maxWidth: "100%",
                  border: "none",
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f7f8fa",
                    borderBottom: "none",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: 600,
                    fontSize: 12,
                    letterSpacing: 0.4,
                  },
                  "& .MuiDataGrid-columnSeparator": { display: "none" },
                  // no padding overrides — the grid's own symmetric padding is
                  // what the old table had
                  "& .MuiDataGrid-cell": {
                    display: "flex",
                    alignItems: "center",
                    borderBottom: "none",
                    overflow: "hidden",
                  },
                  "& .MuiDataGrid-footerContainer": { borderTop: "none" },
                  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within":
                  {
                    outline: "none",
                  },
                }}
              />

              {/* every column hidden — the grid draws nothing, so offer the
                  way back instead of a blank table */}
              {allColumnsHidden && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 12,
                    backgroundColor: "#fff",
                    zIndex: 2,
                  }}
                >
                  <span style={{ fontSize: 14, color: "#667085" }}>
                    All columns are hidden.
                  </span>
                  <button
                    className={styles.addNewUsers1}
                    onClick={openColumnsPanel}
                  >
                    Manage Columns
                  </button>
                </div>
              )}
            </Box>
          </div>
        </div>
      </div>

      {/* per-row action menu — a Popover so it isn't clipped by the grid */}
      <Popover
        open={Boolean(actionMenu.anchorEl)}
        anchorEl={actionMenu.anchorEl}
        onClose={closeActionMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {actionMenu.row && (
          <div>
            {/* COPY KYC LINK */}
            {actionMenu.row.Kyc_status == "Pending" && (
              <div
                className={styles.ActionPopupInnerDiv}
                onClick={async () => {
                  const detail = actionMenu.row;
                  closeActionMenu();
                  copyToClipboard(
                    detail?.kyc_info?.initiate_kyc_bp_response?.kycLink
                      ?.webLink,
                  );
                  setLinkCopied(true);
                  await new Promise((resolve) => setTimeout(resolve, 1500));
                  setLinkCopied(false);
                }}
              >
                Copy KYC Link
              </div>
            )}

            {/* RESEND KYC LINK */}
            {!store.isUserViewAdmin &&
              !store.isUserGlobalViewAdmin &&
              (actionMenu.row.Kyc_status == "Rejected" ||
                actionMenu.row.Kyc_status == "Expired") && (
                <div
                  className={styles.ActionPopupInnerDiv}
                  onClick={async () => {
                    const detail = actionMenu.row;
                    closeActionMenu();
                    resendKycLink(detail);
                    setLinkResend(true);
                    await new Promise((resolve) => setTimeout(resolve, 1500));
                    setLinkResend(false);
                  }}
                >
                  Resend KYC Link
                </div>
              )}

            {actionMenu.row.Kyc_status == "Completed"&&actionMenu.row.roles.includes("CUPI_COMPANY_EMPLOYEE") && (
              <div
                className={styles.ActionPopupInnerDiv}
                onClick={() => {
                  console.log("actionMenu",actionMenu);
                  
                  const detail = actionMenu.row;
                  closeActionMenu();
                  OpenTopup(detail);
                  try {
                    logOpenTopUp();
                  } catch (err) {
                    console.log("error%o", err);
                  }
                }}
              >
                Add Top-Up
              </div>
            )}

            <div
              className={styles.ActionPopupInnerDiv}
              onClick={() => {
                const detail = actionMenu.row;
                closeActionMenu();
                openEditUser(detail);
              }}
            >
              Edit User
            </div>
          </div>
        )}
      </Popover>

      <div></div>
      {editUser && (
        <div className={styles.ViewUserHeader}>
          <EditUserLimits
            isVisible={editUser}
            onClose={() => {
              setEdituser(false);
            }}
          />
        </div>
      )}
      {flag && (
        <div className={styles.newUsersOverlay}>
          <NewUsers
            isVisible={flag}
            onClose={() => {
              setFlag(false);
              store.setEmpDetails("");
            }}
            openNoti={() => {
              setFlagNotifi(true);
            }}
            setAdmin={() => {
              setIsAdmin(true);
            }}
            resetAdmin={() => {
              setIsAdmin(false);
            }}
            setViewAdmin={() => {
              setViewAdmin(true);
            }}
            setUserAccess={() => {
              setIsUser(true);
            }}
          />
        </div>
      )}
      {EditTopUp && (
        <div className={styles.newUsersOverlay}>
          <TopUp
            isVisible={EditTopUp}
            onClose={() => {
              setEditTopUp(false);
            }}
            openNoti={() => {
              setFlagNotifi(true);
              settopUpNoti(true);
              if (refresh) {
                setRefresh(false);
              } else {
                setRefresh(true);
              }
            }}
          />
        </div>
      )}
      {flagNotifi && (
        <div
          className={styles.newUsersOverlay1}
          onClick={() => {
            setFlagNotifi(false);
            settopUpNoti(false);
          }}
        >
          <Notificatio
            isAdmin={isAdmin}
            isVisible={flagNotifi}
            onClose={() => {
              setFlagNotifi(false);
            }}
            TopUpNoti={topUpNoti}
            isViewAdmin={isViewAdmin}
            isUser={isUser}
          />
        </div>
      )}
      {companyStore.showEmpDetails && (
        <div className={styles.newUsersOverlay1}>
          <NewTags />
        </div>
      )}
    </div>
  );
});

UserComponent.propTypes = {
  className: PropTypes.string,
};

export default UserComponent;
